export default __webpack_public_path__ + "static/media/2.528c8386.png";